module.exports = __webpack_public_path__ + "img/Flag_of_Saudi_Arabia.b0d37ffc.png";